import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Luxeo Car | Location Véhicules Premium VTC Marseille",
  description = "Location de Tesla Model Y, Ford Mustang Mach-E et Mercedes Classe V pour chauffeurs VTC à Marseille. Véhicules premium pour Uber et Bolt. À partir de 350€/semaine.",
  keywords = "location Tesla VTC, location véhicule VTC Marseille, chauffeur Uber, voiture électrique VTC",
  canonical = "",
  image = "https://images.unsplash.com/photo-1669625397388-32934837bd3a?w=1200"
}) => {
  const siteUrl = "https://luxeocar.fr";
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
